

/**
 * This is an animated Spinner icon - It looks like a thin spinning circle.
 * It also has a spinning animation.
 * used on logging in via email as reference to the design
 */

export default {
  name: 'Spinner',
};
